// extracted by mini-css-extract-plugin
export default {"dialog":"edit-receipt-categories-modal_dialog__u40Bs","label":"edit-receipt-categories-modal_label__rVU+c","action":"edit-receipt-categories-modal_action__fJce5"};